import React, { useState } from 'react';
import { Button } from 'antd';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { getTodayInTimezone } from 'utils/timezoneUtils';
import { CustomerTier, GET_ORDER_QUOTA_CUSTOMER_TIERS, OrderQuotaCustomerTier } from '../graphql/orderQuotaGraphql';
import CustomerTierModal from './CustomerTierModal';

/** 产能按美西自然日统计，下载文件名的日期同样取美西今日 */
const PACIFIC_TZ = 'America/Los_Angeles';

interface CustomerTierBarProps {
    /** 分级导入成功后通知页面刷新 HUB 列表与当前工作区 */
    onApplied: () => void;
}

/**
 * 分拣产能管理页顶部的客户分级栏。
 * 客户分级对全部 HUB 生效，入口放在 HUB 列表与工作区之上，避免误解为每个 HUB 各有一套分级；
 * 各 HUB 的保障值 / 上限仍在工作区按 HUB 设置。
 */
const CustomerTierBar: React.FC<CustomerTierBarProps> = ({ onApplied }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const { data, refetch } = useQuery<{ onboardingOrderQuotaCustomerTiers: OrderQuotaCustomerTier[] }>(
        GET_ORDER_QUOTA_CUSTOMER_TIERS,
        { fetchPolicy: 'network-only' }
    );
    const tiers = data?.onboardingOrderQuotaCustomerTiers;
    const high = tiers?.filter((item) => item.tier === CustomerTier.HIGH).length ?? 0;
    const low = tiers?.filter((item) => item.tier === CustomerTier.LOW).length ?? 0;

    const handleApplied = async () => {
        await refetch();
        onApplied();
    };

    return (
        <div className="flex flex-wrap items-center justify-between gap-4 px-4 py-3 border-0 border-b border-solid border-[#f0f0f0]">
            <div className="flex flex-wrap items-baseline gap-3">
                <span className="text-sm font-semibold">{t('central.orderQuota.tierBar.title')}</span>
                {tiers && (
                    <span className="text-[13px] text-[#595959]">{t('central.orderQuota.tierBar.count', { high, low })}</span>
                )}
                <span className="text-xs text-[#8c8c8c]">{t('central.orderQuota.tierBar.hint')}</span>
            </div>
            <Button type="primary" onClick={() => setOpen(true)}>
                {t('central.orderQuota.actions.customerTier')}
            </Button>
            <CustomerTierModal
                open={open}
                today={getTodayInTimezone(PACIFIC_TZ).format('YYYY-MM-DD')}
                onCancel={() => setOpen(false)}
                onApplied={handleApplied}
            />
        </div>
    );
};

export default CustomerTierBar;
